import moment from "moment";
import "./../profile.css";
import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import { useSelector } from "react-redux";
import { isBookingCancel } from "../../../constant/utils";

interface IMember {
  open: boolean;
  handleClose: () => void;
  handleEditBooking: (data: any) => void;
}
const BookingDetails = ({ open, handleClose, handleEditBooking }: IMember) => {
  ReactModal.setAppElement("body");
  const bookingDetails = useSelector((state: any) => state?.profile?.bookingDetails || {});
  function subTotal() {
    return testArrActual()?.reduce((total, item) => Number(item?.test_mrp || 0) + total, 0);
  }
  function testArrActual() {
    let crmTest: any[] = bookingDetails?.CrmBookingData?.test_arr || [];
    // return crmTest?.filter((item:any) => item?.test_code !== "G06S07T77");
    return crmTest?.filter((item: any) => !item?.test_code.includes("G06S07T"));
  }
  function homeCollectionCharge() {
    let crmTest: any[] = bookingDetails?.CrmBookingData?.test_arr || [];
    // return crmTest?.find((item:any) => item?.test_code === "G06S07T77")?.test_mrp || 0;
    return crmTest?.find((item: any) => item?.test_code.includes("G06S07T"))?.test_mrp || 0;
  }
  function testArrToShow() {
    let test: any[] = JSON.parse(bookingDetails?.BookingData?.updated_order_details || "[]");
    return test?.filter((item: any) =>
      testArrActual()?.find((ach: any) => ach?.test_code == item?.code) ? true : false
    );
  }
  function testArrOld() {
    let actual_order: any[] = JSON.parse(bookingDetails?.BookingData?.actual_order_details || "[]");
    // return actual_order?.filter((item:any) => item?.code !== "G06S07T77");
    // if(!ele?.code.includes("G06S07T")){

    return actual_order?.filter((item: any) => !item?.code.includes("G06S07T"));
  }
  function removeItems() {
    return testArrOld().filter((ele: any) =>
      testArrActual()?.find((obj: any) => obj?.test_code == ele?.code) ? false : true
    );
  }
  const amountToBeCharged = (mrp: boolean = false) => {
    return Number(bookingDetails?.PaymentTransactions?.AmountToBeCollect || 0);
  };
  return (
    <ReactModal isOpen={open} onRequestClose={handleClose} className="my_acc_modal" overlayClassName="my_acc_overlay">
      <div className="cross_button">
        <img src="/assets/img/my-profile/cross.png" alt="" className="cursor-pointer" onClick={handleClose} />
      </div>
      <div>
        <div className="acc_modal_content">
          <h6 className="pb-3">Booking Details</h6>
          <div className="d-flex flex-wrap justify-content-end align-items-center mb-3" style={{ gap: "16px" }}>
            {bookingDetails?.CrmBookingData?.report_url && (
              <div className="text-right">
                <a
                  href={bookingDetails?.CrmBookingData?.report_url}
                  className="book--hexagon active m-0"
                  target="_blank"
                  style={{ width: "220px" }}
                >
                  <span>
                    <img className="mr-2" src="/assets/img/my-profile/download.png" aria-hidden="true" />
                    Download Report
                  </span>
                </a>
              </div>
            )}
            {bookingDetails?.CrmBookingData?.receipt_url && (
              <div className="text-right">
                <a
                  href={bookingDetails?.CrmBookingData?.receipt_url}
                  className="book--hexagon active m-0"
                  target="_blank"
                  style={{ width: "220px" }}
                >
                  <span>
                    <img className="mr-2" src="/assets/img/my-profile/download.png" aria-hidden="true" />
                    Download Receipt
                  </span>
                </a>
              </div>
            )}
          </div>
          <ul className="nav nav-tabs" id="myTab" role="tablist">
            <li className="nav-item">
              <a className="nav-link active" id="home-tab" data-toggle="tab" href="#OrderDetails">
                <span className="nav-icon">
                  <i className="flaticon2-layers-1"></i>
                </span>
                <span className="nav-text">Order Details</span>
              </a>
            </li>

            {/* <li className="nav-item">
              <a
                className="nav-link"
                id="profile-tab"
                data-toggle="tab"
                href="#CentreAllocation"
                aria-controls="profile"
              >
                <span className="nav-icon">
                  <i className="flaticon2-layers-1"></i>
                </span>
                <span className="nav-text">Centre Allocation</span>
              </a>
            </li> */}
            <li className="nav-item">
              <a className="nav-link" id="contact-tab" data-toggle="tab" href="#PatientDetails" aria-controls="contact">
                <span className="nav-icon">
                  <i className="flaticon2-layers-1"></i>
                </span>
                <span className="nav-text">Patient Details</span>
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                id="contact-tab"
                data-toggle="tab"
                href="#CustomerDetails"
                aria-controls="contact"
              >
                <span className="nav-icon">
                  <i className="flaticon2-layers-1"></i>
                </span>
                <span className="nav-text">Customer Address</span>
              </a>
            </li>
          </ul>
          <div className="tab-content mt-5" id="myTabContent">
            <div className="tab-pane fade active show" id="OrderDetails" role="tabpanel" aria-labelledby="home-tab">
              <div className="row align-items-start">
                {bookingDetails?.BookingData?.updated_at && (
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="profileLabel">Booking Date</label>
                      <input
                        type="text"
                        className="form-control profileInp readonly"
                        value={
                          bookingDetails?.BookingData?.updated_at
                            ? moment(new Date(bookingDetails?.BookingData?.updated_at)).format("DD-MM-YYYY hh:mm:A")
                            : ""
                        }
                        readOnly={true}
                      />
                    </div>
                  </div>
                )}
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="profileLabel">Booking Status</label>
                    <input
                      type="text"
                      className="form-control profileInp readonly"
                      value={bookingDetails?.CrmBookingData?.status_txt || "-"}
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="profileLabel">Schedule Date</label>
                    <input
                      type="text"
                      className="form-control profileInp readonly"
                      value={bookingDetails?.CrmBookingData?.lead_preferred_date}
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="profileLabel">Schedule Time</label>
                    <input
                      type="text"
                      className="form-control profileInp readonly"
                      value={bookingDetails?.CrmBookingData?.lead_preferred_time}
                      readOnly={true}
                    />
                  </div>
                </div>
              </div>
              {bookingDetails?.CrmBookingData?.id ? (
                <table className="table table-bordered">
                  <tbody>
                    <tr>
                      <th style={{ minWidth: "60px" }}>SNo.</th>
                      {/* <th style={{minWidth:"80px"}}>Item Type</th> */}
                      <th style={{ minWidth: "80px" }}>Item Code</th>
                      <th style={{ minWidth: "80px" }}>Item Name</th>
                      <th style={{ minWidth: "80px" }}>Item Qty</th>
                      {/* <th style={{minWidth:"80px"}}>Item MRP</th> */}
                      <th style={{ minWidth: "80px" }}>Item Price</th>
                      <th style={{ minWidth: "80px" }}>Total</th>
                    </tr>
                    {testArrActual()?.map((ele: any, i: number) => (
                      <tr>
                        <td>{i + 1}</td>
                        {/* <td>{ele?.type}</td> */}
                        <td>{ele?.test_code}</td>
                        <td>{ele?.test_name}</td>
                        <td>1</td>
                        {/* <td>₹{ele?.mrp || 0}</td> */}
                        <td>₹{ele?.test_mrp || 0}</td>
                        <td>₹{ele?.test_mrp || 0}</td>
                      </tr>
                    ))}
                    {/* {removeItems()?.length > 0 &&<tr>
                    <th colSpan={5} className="text-danger">Removed Items</th>
                  </tr>} */}
                    {/* {removeItems()?.map((ele: any, i: number) => (
                    <tr className="text-danger">
                      <td>{i+1}</td>
                      <td>{ele?.code}</td>
                      <td>{ele?.name}</td>
                      <td>{ele?.qty}</td>
                      <td>₹{ele?.mrp || 0}</td>
                      <td>₹{ele?.sub_total || 0}</td>
                    </tr>
                  ))} */}
                    <tr>
                      <th colSpan={5}>Sub Total</th>
                      <td>₹{subTotal() || 0}</td>
                    </tr>
                    <tr>
                      <th colSpan={5}>Discount</th>
                      <td>₹{bookingDetails?.CrmBookingData?.discount_overall || 0}</td>
                    </tr>
                    <tr>
                      <th colSpan={5}>Home Collection Charges</th>
                      <td>₹{homeCollectionCharge()}</td>
                    </tr>
                    <tr>
                      <th colSpan={5}>Grand Total</th>
                      <td>₹{bookingDetails?.CrmBookingData?.net_amount || 0}</td>
                    </tr>
                    {bookingDetails?.PaymentTransactions?.AdvanceAmount > 0 &&
                      !isBookingCancel(bookingDetails?.CrmBookingData?.status) && (
                        <tr>
                          <th colSpan={5}>Advance Paid</th>
                          <td>₹{bookingDetails?.PaymentTransactions?.AdvanceAmount || 0}</td>
                        </tr>
                      )}
                    {amountToBeCharged() > 0 && !isBookingCancel(bookingDetails?.CrmBookingData?.status) && (
                      <tr style={{ color: "red" }}>
                        <th colSpan={5}>Amount to be Collected</th>
                        <td>₹{amountToBeCharged() || 0}</td>
                      </tr>
                    )}
                    {/* <tr style={{ background: "#FFE2E5" }}>
                      <th colSpan={5}>Amount to be Refund</th>
                      <td>
                        ₹
                        {(amountToBeCharged() || 0)
                          ?.toString()
                          ?.replace("-", "")}
                      </td>
                    </tr> */}
                    {!isBookingCancel(bookingDetails?.CrmBookingData?.status) && (
                      <tr>
                        <th colSpan={5}>Payment Mode</th>
                        <td className="text-capitalize">
                          {/* {bookingDetails?.CrmBookingData?.payment_mode_txt} */}
                          {bookingDetails?.CrmBookingData?.transaction_id ? "Online" : "-"}
                        </td>
                      </tr>
                    )}
                    {bookingDetails?.CrmBookingData?.transaction_id &&
                    !isBookingCancel(bookingDetails?.CrmBookingData?.status) ? (
                      <tr>
                        <th colSpan={5}>Transaction ID</th>
                        <td className="text-capitalize">{bookingDetails?.CrmBookingData?.transaction_id}</td>
                      </tr>
                    ) : (
                      ""
                    )}
                    {(bookingDetails?.BookingData?.payment_type == "online" ||
                      bookingDetails?.BookingData?.payment_type == "others") &&
                      bookingDetails?.BookingData?.payment_txn_id &&
                      isBookingCancel(bookingDetails?.CrmBookingData?.status) && (
                        <tr>
                          <th colSpan={8}>Your amount will be refunded within 3 working days as per RBI guideline</th>
                        </tr>
                      )}
                  </tbody>
                </table>
              ) : (
                <table className="table table-bordered">
                  <tbody>
                    <tr>
                      <th style={{ minWidth: "60px" }}>SNo.</th>
                      <th style={{ minWidth: "80px" }}>Item Code</th>
                      <th style={{ width: "100px" }}>Item Name</th>
                      <th style={{ minWidth: "80px" }}>Item Price</th>
                      <th style={{ width: "200px" }}>Remark</th>
                      <th style={{ minWidth: "80px" }}>Total</th>
                    </tr>
                    {testArrActual()?.map((ele: any, i: number) => (
                      <tr>
                        <td>{i + 1}</td>
                        <td>{ele?.test_code}</td>
                        <td>{ele?.test_name}</td>
                        <td>₹{ele?.test_mrp || 0}</td>
                        <td>₹{ele?.test_sample_remarks || ""}</td>
                        <td>₹{ele?.test_mrp || 0}</td>
                      </tr>
                    ))}
                    <tr>
                      <th colSpan={5}>Discount</th>
                      <td>₹{bookingDetails?.CrmBookingData?.discount_overall || 0}</td>
                    </tr>
                    <tr>
                      <th colSpan={5}>Home Collection Charges</th>
                      <td>₹{homeCollectionCharge()}</td>
                    </tr>
                    <tr>
                      <th colSpan={5}>Grand Total</th>
                      <td>₹{bookingDetails?.CrmBookingData?.total_amount_payable || 0}</td>
                    </tr>
                    <tr>
                      <th colSpan={5}>Advance Paid</th>
                      <td>₹{bookingDetails?.CrmBookingData?.total_amount_payable || 0}</td>
                    </tr>
                  </tbody>
                </table>
              )}
            </div>
            <div className="tab-pane fade" id="CustomerDetails" role="tabpanel" aria-labelledby="profile-tab">
              <div className="row align-items-start">
                {/* <div className="col-sm-6">
                  <div className="form-group">
                    <label className="profileLabel">Customer Mobile</label>
                    <input
                      type="text"
                      className="form-control profileInp readonly"
                      value={bookingDetails?.customer?.mobile_no}
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="profileLabel">Email</label>
                    <input
                      type="text"
                      className="form-control profileInp readonly"
                      value={bookingDetails?.customer?.email_id}
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="profileLabel">First Name</label>
                    <input
                      type="text"
                      className="form-control profileInp readonly"
                      value={bookingDetails?.customer?.first_name}
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="profileLabel">Last Name</label>
                    <input
                      type="text"
                      className="form-control profileInp readonly"
                      value={bookingDetails?.customer?.last_name}
                      readOnly={true}
                    />
                  </div>
                </div> */}
                {/* <div className="col-sm-6">
                  <div className="form-group">
                    <label className="profileLabel">Address Tag</label>
                    <input
                      type="text"
                      className="form-control profileInp readonly"
                      value={bookingDetails?.CrmBookingData?.address_tag}
                      readOnly={true}
                    />
                  </div>
                </div> */}
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="profileLabel">House no</label>
                    <input
                      type="text"
                      className="form-control profileInp readonly"
                      value={bookingDetails?.CrmBookingData?.house_no}
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="profileLabel">Locality</label>
                    <input
                      type="text"
                      className="form-control profileInp readonly"
                      value={bookingDetails?.CrmBookingData?.address}
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="profileLabel">Pincode</label>
                    <input
                      type="text"
                      className="form-control profileInp readonly"
                      value={bookingDetails?.CrmBookingData?.pin_code}
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="profileLabel">State</label>
                    <input
                      type="text"
                      className="form-control profileInp readonly"
                      value={bookingDetails?.CrmBookingData?.state_txt}
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="profileLabel">City</label>
                    <input
                      type="text"
                      className="form-control profileInp readonly"
                      value={bookingDetails?.CrmBookingData?.city_txt}
                      readOnly={true}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="tab-pane fade" id="PatientDetails" role="tabpanel" aria-labelledby="contact-tab">
              <div className="row align-items-start">
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="profileLabel">Patient Mobile</label>
                    <input
                      type="text"
                      className="form-control profileInp readonly"
                      value={bookingDetails?.CrmBookingData?.mobile_no}
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="profileLabel">Patient First Name</label>
                    <input
                      type="text"
                      className="form-control profileInp readonly"
                      value={bookingDetails?.CrmBookingData?.first_name}
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="profileLabel">Patient Last Name</label>
                    <input
                      type="text"
                      className="form-control profileInp readonly"
                      value={bookingDetails?.CrmBookingData?.last_name}
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="profileLabel">Gender</label>
                    <input
                      type="text"
                      className="form-control profileInp readonly"
                      value={bookingDetails?.CrmBookingData?.gender_txt}
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="profileLabel">DOB</label>
                    <input
                      type="text"
                      className="form-control profileInp readonly"
                      value={bookingDetails?.CrmBookingData?.dob}
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="profileLabel">Customer Relation</label>
                    <input
                      type="text"
                      className="form-control profileInp readonly"
                      value={bookingDetails?.CrmBookingData?.customer_relation_txt}
                      readOnly={true}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* <div
              className="tab-pane fade"
              id="CentreAllocation"
              role="tabpanel"
              aria-labelledby="contact-tab"
            >
              <div className="row align-items-start">
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="profileLabel">Centre Name</label>
                    <input
                      type="text"
                      className="form-control profileInp readonly"
                      value={bookingDetails?.address_tag}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="profileLabel">Centre Address</label>
                    <input
                      type="text"
                      className="form-control profileInp readonly"
                      value={bookingDetails?.address}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="profileLabel">Centre City</label>
                    <input
                      type="text"
                      className="form-control profileInp readonly"
                      value={bookingDetails?.customer_firstname}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="profileLabel">Centre State</label>
                    <input
                      type="text"
                      className="form-control profileInp readonly"
                      value={bookingDetails?.customer_lastname}
                    />
                  </div>
                </div>
              </div>
            </div> */}
          </div>
          {bookingDetails?.BookingData?.id &&
            bookingDetails?.CrmBookingData?.status != "booking_cancelled" &&
            bookingDetails?.CrmBookingData?.status == "pending_from_phlebotomist" &&
            moment(bookingDetails?.CrmBookingData?.lead_preferred_date, "DD-MM-YYYY").diff(moment(), "days") >= 0 && (
              <div className="text-center">
                <button
                  type="button"
                  className="book--hexagon active sm_form"
                  onClick={() => handleEditBooking(bookingDetails)}
                >
                  <span>
                    Edit Booking
                    <i className="fa fa-long-arrow-right ml-20" aria-hidden="true"></i>
                  </span>
                </button>
              </div>
            )}
        </div>
      </div>
    </ReactModal>
  );
};

export default BookingDetails;
